module.exports = __webpack_public_path__ + "img/wiksaView.d442f371.jpeg";